import React, { useRef, useLayoutEffect, useEffect, useState} from 'react'
import { useForm } from "react-hook-form"
import styled from 'styled-components'
import { StyledError, FormGeneralError } from '../update-info-form/form-helpers'
import ReactHtmlParser from 'react-html-parser'
import { mixins, colors } from "../css-variables"

const EmailTermsForm = ({formId}) => {
  const [generalError, setGeneralError] = useState('')
  const [formLoading, setLoadingState] = useState(false)
  const { register, handleSubmit, setValue, formState: {  isDirty, isValid, errors } } = useForm({mode : 'onChange'})
  const [defaultValue, setDefaultValue] = useState(null);
  const [secondDefaultValue, setSecondDefaultValue] = useState(null);

  const SubmitForm = (data, e) => {
    if (!formLoading) {
      setLoadingState(true)

      let entryData = {
        "payload":{ 
          "input_2": data.email, 
          "input_8": data.consent,
          "input_1": data.fullname,
          "input_6": data.lookup_id,
        }
      }
      
      return fetch(`${process.env.GATSBY_GRAVITYFORMS_SOURCE || "https://uwalumni.wpengine.com"}/wp-json/formsubmit/v1/submit/${formId}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(entryData),
      }).then(res =>
        (!res.ok)
          ? res.json().then(() => {throw new Error('An error occurred when trying to submit the form.')})
          : res.json().then((data) => {
            if(data?.is_valid && data?.confirmation_message){
              if(entryData?.payload["input_8"] === "I choose to close my uwalumni.com account"){
                window.location.href = "/email/successful-form-submission-alumni-email-account-preference/";
              } else {
                window.location.href = "/email/successful-form-submission-alumni-email/";
              }
            }
          })
      ).catch(err => {setGeneralError(err.message)})
    }
  }
  //check if things are loaded, component did mount
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
      if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
      }
  });
  useEffect(() => {
      const emailParam = getEmailFromQueryString('uwa_email')
      setDefaultValue(emailParam)
      if(emailParam){
        setValue('email', emailParam, {
          shouldValidate: true,
          shouldDirty: true
        })
      }
      const lookupIdParam = getEmailFromQueryString('lookup_id')
      setSecondDefaultValue(lookupIdParam)
      if(lookupIdParam){
        setValue('lookup_id', lookupIdParam, {
          shouldValidate: true,
          shouldDirty: true
        })
      }
      
  }, [firstUpdate.current]);

  const getEmailFromQueryString = (paramToCheck) => {
    const queryToCheck = firstUpdate.current === false ? new URLSearchParams(document.location.search.substring(1)): null;
    const param = paramToCheck && queryToCheck ? queryToCheck.get(paramToCheck) : null;
    const hiddenValue = param && param.match(/^[0-9a-zA-Z _%@.-]+$/)? param : null; 
    return hiddenValue !== null ? hiddenValue : null
  }

      return (
        <StyledEmailTermsForm>
          <div>
            {generalError && (
              <FormGeneralError>We’re sorry, but a network issue prevented us from saving your information. Our team has been notified, but you can <a href="mailto:web@supportuw.org">contact WAA</a> if you need immediate assistance.</FormGeneralError>
            )}
            <form
              id="email-terms"
              onSubmit={handleSubmit(SubmitForm)}
            >
              {Object.keys(errors).length !== 0 && (
                <StyledError className="topError">
                  Please correct error(s) below
                </StyledError>
              )}
              <ul>
                <li>
                <label htmlFor="email" className="half required">
                  Enter your uwalumni.com email
                  <span className="required">*</span>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    maxLength="255"
                    defaultValue={defaultValue}
                    placeholder='example@uwalumni.com'
                    {...register("email", {
                      required: {
                        value: true,
                        message: "Your uwalumni.com email is required",
                      },
                      pattern: {
                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: "Must be valid email address",
                      },
                      validate: {
                          uwaEmail: (value) => value.includes('@uwalumni.com')
                      },
                    })}
                  />
                  {errors.email && errors.email.type !== 'uwaEmail' && (
                    <StyledError>{errors.email.message}</StyledError>
                  )}
                  {errors.email && errors.email.type === 'uwaEmail' && (
                    <StyledError>Please submit your uwalumni.com email.</StyledError>
                  )}
                </label>
              </li>
              <li>
                <label htmlFor="consent" selected>Email Account Choice
                  <span className="required">*</span></label>
                <input type="radio" name="consent" id="consent" required {...register("consent", {})} value="I wish to keep my uwalumni.com account and I accept the Terms & Conditions outlined below" />
                <label htmlFor="consent" className="normal-weight">I wish to keep my uwalumni.com account and I accept the Terms & Conditions outlined below</label>
                <input type="radio" name="consent" id="noconsent" required {...register("consent",{})} value="I choose to close my uwalumni.com account"/>
                <label htmlFor="noconsent" className="normal-weight">I choose to close my uwalumni.com account</label>
                  {errors.consent && (
                    <StyledError>{errors.consent.message}</StyledError>
                  )}
              </li>
              <p>You must either agree to the Terms & Conditions or agree to close your account.</p>
              <li>
                <label htmlFor="fullname" className="half leftMargin required">
                  Sign with your Full Name
                  <span className="required">*</span>
                  <input
                    type="text"
                    name="fullname"
                    id="fullname"
                    maxLength="202"
                    {...register("fullname", {
                      required: { value: true, message: "Full name signature is required" },
                      maxLength: {
                        value: 201,
                        message: "Full name cannot be more than 200 characters",
                      },
                      pattern: {
                        value: /^[a-zA-Z' -]+$/,
                        message: 'Name can only contain letters, hyphens and apostrophes.',
                      },
                    })}
                  />
                  {errors.fullname && (
                    <StyledError>{errors.fullname.message}</StyledError>
                  )}
                </label>
                </li>
                <li style={{display: 'none'}}>
                  <label htmlFor="lookup_id" className="half leftMargin required">
                    Lookup ID
                    <input
                      type="text"
                      name="lookup_id"
                      id="lookup_id"
                      maxLength="202"
                      defaultValue={secondDefaultValue}
                      {...register("lookup_id", {
                        maxLength: {
                          value: 201,
                          message: "Lookup ID cannot be more than 200 characters",
                        },
                      })}
                    />
                  </label>
                </li>
              </ul>
              { !isValid && (<p className="validFormMessage">Please complete all required (<span>*</span>) fields and correct any error(s) above. </p>) }
              <button
                  type="submit"
                  name="submit"
                  id="submit"
                  disabled={formLoading || ( !isDirty || !isValid) }
                  >{formLoading ? 'Loading' : 'Submit'}</button>
            </form>
          </div>
        </StyledEmailTermsForm>
      )
}

const StyledEmailTermsForm = styled.div`
text-align: left;
margin-bottom: 30px;
a{
  color: ${colors.badgerRed};
}
#form-confirmation{
  padding-top: 48px;
  margin-top: 48px;
  border-top: 2px solid rgb(204, 204, 204);
}
form{
  ${mixins.formStyles}
  input[type='radio'] + label{
    padding: 0;
  }
  input[type='radio']:checked + label::after{
    left: 3px;
  }
  span.required{
    color: ${colors.badgerRed};
    margin-left: 5px;
  }
  ul{
    margin: 0;
    li{
      list-style:none;
      margin-bottom: 24px;
      label{
        font-weight: bold;
        &.normal-weight, p{
          font-weight: normal;
        }
        p{
          font-size:16px;
          :before{
            width: 16px;
            height: 16px;
            top: 0;
          }
        }
      }
      input{
        margin-top: 12px;
        font-weight: normal;
      }
    }
  }
  button{
    ${mixins.buttons}
    border:none;
    cursor:pointer;
    :disabled{
        background-color: #CCCCCC;
        cursor: auto;
        :hover{
            box-shadow:none;
        }
    }
  }
  .topError{
    top: auto;
    margin-top: -20px;
  }
  .validFormMessage{
    font-size: 18px;
    font-weight:500;
    span{
      color: ${colors.badgerRed};
    }
  }
}
`;

export default EmailTermsForm;
